<div class="header" role="navigation">
  <div class="left">
    <a href="/label/show/luxaudienceaward" aria-label="Logo LUX audience award">
        <h1>
            <img src="/assets/images/lux-audience-award.png" alt="Lux Audience Awards logo" height="80">
        </h1>
    </a>
  </div>
  <div class="right">
    @let currentUser = authenticationService.currentUser$ | async;
    @if (currentUser) {
      <span class="authenticated-as">
        {{ 'lux.front.header.authenticated_as' | translate }}  {{ currentUser?.email }}
      </span>
      <div class="action-container">
        <mat-form-field appearance="outline" class="language-select mat-form-field-no-subscript">
          <mat-select
            [value]="currentLanguage"
            (selectionChange)="changeLanguage($event.value)"
            aria-label="Choose your language"
          >
            @for (lang of languages; track lang.code) {
              <mat-option [value]="lang.code">
                {{ lang.label }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <button mat-icon-button (click)="logout()" aria-label="logout" title="{{ 'lux.front.header.logout' | translate }}">
          <span class="button-label-container">
            <lucide-icon [img]="Power" size="15" color="white"></lucide-icon>
          </span>
        </button>
      </div>
    }
  </div>
</div>
<span class="authenticated-as-mobile">{{ 'lux.front.header.authenticated_as' | translate }} {{ currentUser?.email }}</span>
